import { render, staticRenderFns } from "./goodsStatus.vue?vue&type=template&id=46733682&scoped=true"
import script from "./goodsStatus.vue?vue&type=script&lang=js"
export * from "./goodsStatus.vue?vue&type=script&lang=js"
import style0 from "./goodsStatus.vue?vue&type=style&index=0&id=46733682&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46733682",
  null
  
)

export default component.exports